import { render, staticRenderFns } from "./FAQGroupSelector.vue?vue&type=template&id=459f360c&"
import script from "./FAQGroupSelector.vue?vue&type=script&lang=js&"
export * from "./FAQGroupSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports